export const navLinks = [
  { name: 'Home', to: '/' },
  {
    name: 'About Us', to: '/about',
    dropdown: [
      { name: 'About Us', to: '/about' },
      { name: 'Prant Karyakarini', to: '/prant-karyakarini', external: 'https://www.sewabhartiharyana.org/wp-content/uploads/2025/04/PRANT-KARYAKARINI-2024-2025.pdf' },
    ]
  },
  { name: 'Our Initiatives', to: '/initiatives' },
  { name: 'Campaign', to: '/campaign' },
  { name: 'Media', to: '/media' },
  { name: 'Get Involved', to: '/get-involved' },
  {
    name: 'Gallery', to: '/events',
    dropdown: [
      { name: 'Photos', to: '/events' },
      { name: 'Videos', to: '/videos' },
    ]
  },
  { name: 'Contact Us', to: '/contact' },
]
